<template>
  <div>
    <div class="Home-Imgs">
      <div class="Home-Img-left">
        <div class="left_Bottom">
          <div class="left_Bottom2" v-for="(item, index) in list2" :key="index">
            <img :src="item.ImgUrl" :class="index==0 || index==3 ?'imgs':''" />
            <div class="left_P">
              <div class="leftflex">
                <p>{{ item.name }}</p>
              </div>
              <p v-if="index != 2" class="notranslate">{{ item.shizi }}</p>
              <p v-else class="notranslate">
                {{ theTime2 }} h {{ theTime1 }} m {{ theTime }} s
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetHomeData } from "@/assets/server/api";
export default {
  name: "TransforBrowserHomeTop",
  props: {
    tpsCount: String,
  },
  data() {
    return {
      list1: [
        {
          ImgUrl: require("@/assets/pc/HomeTop/Home7.png"),
          name: "Validators / Network nodes",
          shizi: "0",
        },
        {
          ImgUrl: require("@/assets/pc/HomeTop/Home4.png"),

          name: "Gas",
          shizi: "0",
        },
        {
          ImgUrl: require("@/assets/pc/HomeTop/Home6.png"),
          name: "Total flux",
          shizi: "0",
        },
        {
          ImgUrl: require("@/assets/pc/HomeTop/Home8.png"),
          name: "Transactions per second",
          shizi: "0",
        },
      ],
      list2: [
        {
          ImgUrl: require("@/assets/pc/HomeTop/Home5.png"),
          name: "Staking Rate",
          shizi: "0%",
        },
        {
          ImgUrl: require("@/assets/pc/HomeTop/Home3.png"),
          name: "Current APR",
          shizi: "0%",
          ImgUrl1: require("@/assets/pc/charts/tanh.png"),
        },
        {
          ImgUrl: require("@/assets/pc/HomeTop/Home2.png"),
          name: "To the next bonus era",
          shizi: "0",
        },
        {
          ImgUrl: require("@/assets/pc/HomeTop/Home9.png"),
          name: "Deflation",
          shizi: "0",
        },
      ],
      theTime: 0, 
      theTime1: 0, 
      theTime2: 0, 
      Time: null,
      allNodes: 0,
      flog: false,
    };
  },
  created() {
    this.HomeList();
  },
  mounted() {},
  watch: {
    deep: true,
    tpsCount(val) {
    //  console.log(val);
      this.tpsCounts = val;
   //   console.log(this.tpsCounts);
      this.list1[3].shizi = this.tpsCounts;
    },
  },
  methods: {
    async HomeList() {
      let data = await GetHomeData();
   //   console.log(data);
      this.list2[0].shizi = data.result.stakePercent;
      this.list2[1].shizi = data.result.awardPercent;
      this.list2[2].shizi = data.result.nextDuring / 1000;
      this.list2[3].shizi = data.result.burn;
      this.list1[0].shizi = data.result.validators;

      this.list1[1].shizi = data.result.maxGas;
      this.list1[2].shizi = data.result.totalFlux;
      this.allNodes = "/ " + data.result.allNodes;
      this.list1[3].shizi = data.result.tpsCount;
      this.shijan();
    },
    shijan() {
      this.Time = setInterval(async () => {
        var aaa = new Date().getTime();      
        this.list2[2].shizi--;
        this.theTime = parseInt(this.list2[2].shizi); 
        this.theTime1 = 0; 
        this.theTime2 = 0; 
        if (this.theTime > 60) {
          this.theTime1 = parseInt(this.theTime / 60);
          if (this.theTime > 1) {
            this.theTime = parseInt(this.theTime % 60);
          } else {
            this.theTime = 60;
          }
          if (this.theTime1 > 60) {
            this.theTime2 = parseInt(this.theTime1 / 60);
            if (this.theTime1 > 1) {
              this.theTime1 = parseInt(this.theTime1 % 60);
            } else {
              this.theTime1 = 60;
            }
            if (this.theTime2 > 24) {
              this.theTime2 = parseInt(this.theTime2 % 24);
            }
          }
        }
      }, 1000);

     
    },
  },
  beforeDestroy() {
    clearInterval(this.Time); 
    this.Time = null;
  },
};
</script>

<style lang="less" scoped>
.Home-Imgs {
  // display: flex;
  .Home-Img-left {
    // flex: 0 0 80%;
    .left_Top {
      // border: 1px solid red;
      display: flex;
      flex-direction: row;
      // justify-content: space-around;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .left_Top2 {
        // flex: 1;
        // border: 1px solid yellow;
        width: 280px;
        height: 92px;
        background: #232a35;
        border-radius: 16px 16px 16px 16px;
        padding: 21px 10px;
        margin: 40px 0px 20px 0;
        img {
          width: 50px;
          height: 50px;
          float: left;
          margin-right: 10px;
        }
        .left_P {
          p:nth-child(1) {
            font-size: 14px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.55);
            line-height: 22px;
            -webkit-background-clip: text;
          }
          p:nth-child(2) {
            font-size: 22px;
            font-family: SF Pro Display-Semibold, SF Pro Display;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.9);
            line-height: 30px;
            -webkit-background-clip: text;
            span {
              font-size: 14px;
              font-family: SF Pro Text-Regular, SF Pro Text;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.55);
            }
          }
        }
      }
      .left_Top2:nth-child(3) {
        margin-right: 0;
      }
    }
    .left_Bottom {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .left_Bottom2 {
        width: 280px;
        height: 92px;
        background: #232a35;
        border-radius: 16px 16px 16px 16px;
        padding: 21px 10px;
        margin: 0 0px 20px 0;
        .imgs{
          width: 60px;
          height: 60px;
        }
        img {
          width: 50px;
          height: 50px;
          float: left;
          margin-right: 10px;
        }
        .left_P {
          .leftflex {
            display: flex;
            img {
              cursor: pointer;
              width: 18px;
              height: 18px;
              margin-left: 6px;
              margin-top: 2px;
            }
          }
          p:nth-child(1) {
            font-size: 14px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.55);
            line-height: 22px;
            -webkit-background-clip: text;
          }
          p:nth-child(2) {
            font-size: 22px;
            font-family: SF Pro Display-Semibold, SF Pro Display;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.9);
            line-height: 30px;
            -webkit-background-clip: text;
          }
        }
      }
      .left_Bottom2:nth-child(3) {
        margin-right: 0;
      }
    }
    .tankangs {
      padding: 10px;
      position: absolute;
      left: 220px;
      top: -54px;
      border-radius: 6px;
      background: rgba(0, 0, 0, 0.75);
      color: #ffffff;
      p {
        font-size: 12px;
        color: #ffffff;
      }
    }
  }
}
</style>
